import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './ConversationList.css';
import ConfirmDialog from '../confirmDialog';

const ConversationList = ({ conversations, currentConversationId, onSelectConversation, onDeleteConversation }) => {
  const { t } = useTranslation();
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [conversationToDelete, setConversationToDelete] = useState(null);

  const handleDelete = (e, conversationId) => {
    e.stopPropagation();
    setConversationToDelete(conversationId);
    setShowDeleteConfirm(true);
  };

  const handleDeleteConfirm = () => {
    if (conversationToDelete) {
      onDeleteConversation(conversationToDelete);
    }
    setShowDeleteConfirm(false);
    setConversationToDelete(null);
  };

  return (
    <div className="conversation-list">
      {conversations.length === 0 ? (
        <div className="conversation-list-empty">
          <p>{t('conversationList.noConversations', '暂无对话')}</p>
          <p className="conversation-list-empty-hint">{t('conversationList.startNewChat', '开始新对话')}</p>
        </div>
      ) : (
        conversations.map((conversation) => (
          <div
            key={conversation.id}
            className={`conversation-item ${currentConversationId === conversation.id ? 'active' : ''}`}
            onClick={() => onSelectConversation(conversation.id)}
          >
            <div className="conversation-item-content">
              <div className="conversation-item-icon">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
                </svg>
              </div>
              <div className="conversation-item-text">
                <div className="conversation-item-title">{conversation.title}</div>
                <div className="conversation-item-preview">
                  {conversation.preview || t('conversationList.newConversation', '新对话')}
                </div>
              </div>
            </div>
            <button
              className="conversation-item-delete"
              onClick={(e) => handleDelete(e, conversation.id)}
              title={t('conversationList.deleteConversation', '删除对话')}
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
              </svg>
            </button>
          </div>
        ))
      )}
      
      <ConfirmDialog
        isOpen={showDeleteConfirm}
        onClose={() => {
          setShowDeleteConfirm(false);
          setConversationToDelete(null);
        }}
        onConfirm={handleDeleteConfirm}
        title={t('conversationList.deleteConversationTitle', '删除对话')}
        message={t('conversationList.deleteConversationMessage', '您确定要删除此对话吗？此操作无法撤销。')}
        confirmText={t('conversationList.delete', '删除')}
        cancelText={t('confirmDialog.cancel')}
        type="danger"
      />
    </div>
  );
};

export default ConversationList;

